<script setup>
import { computed, defineProps, onMounted } from "vue";
import { useRoute } from "vue-router";
import CheckMarkIcon from "@/components/forms/SharedComponents/CheckMarkIcon.vue";
import { useShowTranscriptReleaseTile } from "@/components/forms/TranscriptRelease/composables/useShowTranscriptReleaseTile.js";
import { FORMS_SUBMISSIONS } from "@/constants.js";
import { eventBus } from "@/eventBus.js";

defineOptions({
  name: "TranscriptReleaseCard",
});

const { showTranscriptReleaseTile } = useShowTranscriptReleaseTile();
const route = useRoute();
const props = defineProps({
  formSubmissions: {
    type: Array,
    default: () => [],
  },
});

const applicationId = computed(() => route.params.applicationId);
const completed = computed(() =>
  (props.formSubmissions || []).some(
    (submission) => submission.form_name === FORMS_SUBMISSIONS.transcriptRelease.name,
  ),
);

onMounted(() => {
  if (showTranscriptReleaseTile.value) {
    eventBus.$emit("addPreDepartureForm", {
      label: FORMS_SUBMISSIONS.transcriptRelease.name,
      ruleName: FORMS_SUBMISSIONS.transcriptRelease.name,
      routeName: FORMS_SUBMISSIONS.transcriptRelease.slug,
      submitted: completed.value,
    });
  }
});
</script>

<template>
  <div v-if="showTranscriptReleaseTile" class="flex flex-col">
    <router-link
      :to="{
        name: FORMS_SUBMISSIONS.transcriptRelease.slug,
        params: { applicationId },
      }"
      class="flex flex-row justify-start items-center mb-2"
    >
      <CheckMarkIcon :completed="completed" />
      <p class="text-sm font-semibold ml-4" :class="completed ? 'text-gray-650' : 'text-cyan-700'">
        {{ FORMS_SUBMISSIONS.transcriptRelease.name }}
      </p>
    </router-link>
  </div>
</template>
